export default "__VITE_ASSET__BLch4bYo__"